.infoText {
  color: var(--body-text-arrows-400);
}

#local-sandbox-instance-form-field {
  margin-left: calc(var(--spacer) * 3.3);
}

gz-dropdown {
  --form-field-input-width: 400px;
}
